import {h} from "preact";
import {useEffect, useState} from 'preact/hooks'
import './card-dashboard-styles.scss'
import {t} from "../../../_i18n";
import {Link} from "react-router-dom";
import './card-dashboard-session-styles.scss'
import {useDispatch, useSelector} from "react-redux";
import {fetchInformativeSessions, getSessionURL} from "../../../_rx/informative-sessions/actions";
import {isMobileAgent} from "../../common";
import {toastService} from "../../../_services/toast-service";
import {LANG_ES, LANG_FR, LANG_IT} from "../../../constants";
import getLangByShopId from "../../utils/getLang";

export default function CardSession () {
    const [sessionData, setSessionData] = useState(null); // Estado para guardar los datos de la sesión.
    const [loading, setLoading] = useState(true); // Estado para indicar si está cargando.
    const dispatch = useDispatch();
    const { informativeSessions, student_meta } = useSelector(state => ({
        informativeSessions: state.informativeSessionReducer.informativeSessions,
        student_meta: state.status.student_meta
    }));
    const isMobile = isMobileAgent();

    useEffect(() => {
        dispatch((fetchInformativeSessions()));
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const langMapping = { [LANG_ES]: 'es-ES', [LANG_IT]: 'it-IT', [LANG_FR]: 'fr-FR' };
        const options = { day: 'numeric', month: 'long' };
        const lang = getLangByShopId(student_meta.shop_id);
        const locale = langMapping[lang] || 'es-ES';
        const formattedDate = date.toLocaleDateString(locale, options);
        const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false};
        const formattedTime = date.toLocaleTimeString(locale, timeOptions);
        return `${formattedDate} ${t('formato fecha')} ${formattedTime}`;
    };

    const handleClick = async (uuid) => {
        try {
            const payload = await dispatch(getSessionURL(uuid));
            const sessionURL = payload?.url;

            if (sessionURL) {
                window.location.href = sessionURL;
            }

        } catch (error) {
            toastService.showToast({
                message: t("Error al obtener la URL de la sesión."),
                type: 'danger'
            });
        }
    };

    return (informativeSessions && informativeSessions.length > 0 && (
            <div className={`${!isMobile ? 'card-dashboard-session' : 'card-dashboard-session-mobile'}`}>
                <div>
                    <div className='card-dashboard-session__header'>
                        <h2>{t('Sesiones informativas')}</h2>
                    </div>
                    {informativeSessions.map(session => (
                        <div key={session.uuid} className='card-dashboard-session__content'>
                            <span className="grey"> {formatDate(session.start_at)} </span>
                            <p className="type-sesion">
                                {session.name}
                            </p>
                            <div className="url">

                                <div class="without-text-decoration container-tag">
                                    <Link to={`/informative-session/${session.uuid}`} class="without-text-decoration">
                                        {t('Ver detalles')}
                                        <i className="far fa-arrow-right p-left-half" aria-hidden="true"></i>
                                    </Link>
                                    {!!session.is_running && (
                                        <p class="tag" onClick={() => handleClick(session.uuid)}>
                                            <i className="fas fa-play-circle p-left-half p-right-half"
                                               aria-hidden="true"></i>
                                            <span className="direct">{t('En directo')}</span>
                                        </p>
                                    )}
                                </div>

                            </div>
                            <hr className='separator-xxs'/>
                        </div>
                    ))}
                    <div className="url">
                        <Link to={"/informative-sessions/"} class="without-text-decoration">
                            {t('Ver todas las sesiones')}
                            <i className="far fa-arrow-right p-left-half" aria-hidden="true"></i>
                        </Link>
                    </div>
                </div>
            </div>
        )
    )
}
